module.exports = __webpack_public_path__ + "img/HARVESTER.8b19c846.svg";